import { useLocationChange } from "@hooks/useLocationChange";
import { isAuthenticated } from "@utils/auth";
import { useNavigate } from "react-router-dom";
import { PATHS } from "@/constants";

export const useRouteAuth = () => {
  const navigate = useNavigate();

  useLocationChange((location) => {
    const isDashboard = PATHS.DASHBOARD === location;
    const islogin = PATHS.LOGIN === location;
    const navigateToLogin = !isAuthenticated() && isDashboard;
    const navigateToDashboad = isAuthenticated() && islogin;
    if (navigateToLogin) {
      return navigate(PATHS.LOGIN);
    }
    if (navigateToDashboad) {
      return navigate(PATHS.DASHBOARD);
    }
  });
};
